import UntrackedModel from "../../untracked/untrackedModel";
import IRepo from "../../../interfaces/repo";
import Repo from "../../../state/modules/repo";
import JoinProvider from "../../../providers/appRequests/organizations/joinProvider";
import IJoin from "../../../interfaces/app_requests/organizations/joinInterfaces";
import {DecisionType} from "../../../enums/decisionType";

export default class Join extends UntrackedModel implements IJoin {
  static repo: IRepo<Join, JoinProvider> = new Repo<Join, JoinProvider>('organizationJoins', Join, {}, new JoinProvider(Join,  'join', 'joins', 'organizations/:organization_id/joins'));
  repo: IRepo<this, JoinProvider<this>>;

  user_id: string;
  organization_id: string;
  organization_subdomain: string;
  c_at: string;
  u_at: string;
  decided_at: string;
  decider_id: string;
  decision: DecisionType;
  requester_id: string;

  get isPending(): boolean {
    return this.decision === null;
  }
}
